import React from "react";

import {
  CADENCE_TAG_CLASS,
  cadenceTagTitle,
  type CadenceTag as CadenceTagModel,
} from "../../Utils/Helper/cadenceExecutiveDisplay";

const CadenceTag: React.FC<{ tag: CadenceTagModel }> = ({ tag }) => (
  <span className={CADENCE_TAG_CLASS[tag.tone]} title={cadenceTagTitle(tag)}>
    {tag.label === "Not assessed" ? (
      <span>{tag.label}</span>
    ) : (
      <>
        <span aria-hidden>{tag.mark}</span>
        <span aria-hidden>·</span>
        <span>{tag.label}</span>
        {tag.value ? (
          <>
            <span aria-hidden>·</span>
            <span>{tag.value}</span>
          </>
        ) : null}
      </>
    )}
  </span>
);

export default CadenceTag;
